<h3>PFT/CFT Event Performance</h3>
<div >
    <mat-spinner *ngIf="loading" style="margin: auto;"></mat-spinner>
</div>
<div *ngIf="!loading && graph">
    <plotly-plot [data]="graph.data" [layout]="graph.layout" [config]="graph.config">
    </plotly-plot>
</div>
